import React, { useEffect, useRef } from 'react';
import { ScrollPaginationProps } from './type/scroll-pagination.types';
import '../../../styles/component/scroll-pagination.scss';

const ScrollPagination: React.FC<ScrollPaginationProps> = ({
                                                               hasNext,
                                                               hasPrevious,
                                                               isLoading,
                                                               loadNext,
                                                               loadPrevious,
                                                               className,
                                                               children,
                                                           }) => {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const topRef = useRef<HTMLDivElement | null>(null);
    const bottomRef = useRef<HTMLDivElement | null>(null);
    const lockRef = useRef(false);

    // prevent multiple api calls
    useEffect(() => {
        if (!isLoading) lockRef.current = false;
    }, [isLoading]);

    useEffect(() => {
        const root = containerRef.current;
        if (!root || !topRef.current || !bottomRef.current) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (lockRef.current) return;
                entries.forEach(entry => {
                    if (!entry.isIntersecting) return;
                    if (entry.target === bottomRef.current && hasNext) {
                        lockRef.current = true;
                        loadNext();
                    } else if (entry.target === topRef.current && hasPrevious) {
                        lockRef.current = true;
                        loadPrevious();
                    }
                });
            },
            {
                root: containerRef.current,
                rootMargin: '50px',
            }
        );

        observer.observe(topRef.current);
        observer.observe(bottomRef.current);

        return () => observer.disconnect();
    }, [hasNext, hasPrevious, loadNext, loadPrevious]);

    return (
        <div ref={containerRef} className={`scroll-pagination ${className ?? ''}`}>
            <div ref={topRef} style={{height: 1}}/>
            {children}
            <div ref={bottomRef} style={{height: 1}}/>
        </div>
    );
};

export default ScrollPagination;
